module.exports = __webpack_public_path__ + "img/smiley VJ.f07de34e.svg";